export default "/images/folha_sp.svg?cf7c7a71b59944af7f0b30d351581810";